import { render, staticRenderFns } from "./customerMain.vue?vue&type=template&id=2de5d2ce&scoped=true&"
import script from "./customerMain.vue?vue&type=script&lang=js&"
export * from "./customerMain.vue?vue&type=script&lang=js&"
import style0 from "./customerMain.vue?vue&type=style&index=0&id=2de5d2ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de5d2ce",
  null
  
)

export default component.exports